import type { Formula } from "@intergamma/common/formula"
import { Footer as IntergammaFooter } from "@intergamma/footer"
import { useTranslation } from "react-i18next"

export function Footer({ formula }: { formula: Formula }) {
  const { t, i18n } = useTranslation(["ig-footer", "ig-legal-footer"])

  return <IntergammaFooter formula={formula} t={t} lang={i18n.language} />
}
